import { useTranslation } from "react-i18next"
export const LocalGridFooter = (props:{loadedCount:number,totalCount?:number,loadMore?:()=>void,loading?:boolean,className?:string})=>{
   const {t}=useTranslation();
   return ( <div className={`data p-2 bg-white ${props.className??""}`}>
    <p className="float-right">{t("label.loaded")} {props.loadedCount} {t("label.out-of")} {props.totalCount}</p>
</div>)
}